// Components
import ComponentAdd from '@/components/components/ComponentAdd'
import Breadcrumbs from '@/components/ui/Breadcrumbs'

import ComponentsTable from '@/components/components/ComponentsTable'

export default function ComponentsPage() {
    return (
        <div>
            <Breadcrumbs
                rightSection={
                    <div className="flex gap-2">
                        <ComponentAdd />
                    </div>
                }
                breadcrumbs={[
                    {
                        label: 'Composants',
                    },
                ]}
            />

            <ComponentsTable />
        </div>
    )
}
